import { Bot } from "lucide-react";
import {
	Sheet,
	SheetContent,
	SheetDescription,
	SheetTitle,
} from "../ui/sheet";
import { AgentChatPanel } from "./AgentChatPanel";

/**
 * L'assistente fuori dal Program Builder, in un pannello laterale.
 * Spec: docs/ai-program/10-byok-and-mcp-rework.md (Fase 4).
 *
 * Esiste perche' il dock del builder era l'**unico** ingresso all'assistente:
 * per creare un programma da zero bisognava gia' esserne dentro un altro, e
 * un'analisi atleta non aveva proprio una porta. Il motore era lo stesso, a
 * mancare erano i punti d'ingresso.
 *
 * E' un contenitore, non una seconda chat: la conversazione resta
 * `AgentChatPanel`, cosi' le due superfici non divergono.
 */
export function AgentChatSheet({
	open,
	onOpenChange,
	title,
	description,
	programId = null,
	athleteIds = [],
	onProgramCreated,
	modelId = null,
	modelSport = null,
	onModelsChanged,
}) {
	return (
		<Sheet open={open} onOpenChange={onOpenChange}>
			<SheetContent
				side="right"
				className="w-full sm:max-w-md p-0 flex flex-col gap-0"
			>
				<div className="border-b border-border px-4 py-3">
					<SheetTitle className="font-heading text-base flex items-center gap-2">
						<Bot className="h-4 w-4 text-volt" />
						{title}
					</SheetTitle>
					<SheetDescription className="text-xs">{description}</SheetDescription>
				</div>
				<div className="min-h-0 flex-1">
					<AgentChatPanel
						programId={programId}
						athleteIds={athleteIds}
						onProgramCreated={onProgramCreated}
						modelId={modelId}
						modelSport={modelSport}
						onModelsChanged={onModelsChanged}
					/>
				</div>
			</SheetContent>
		</Sheet>
	);
}
